/* eslint-disable max-len */
import React from 'react'

const Logout = ({ariaHidden}) => (
  <svg
    aria-hidden={ariaHidden}
    width="22px"
    height="24px"
    viewBox="0 0 22 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-1867.000000, -23.000000)"
        fill="#CCCCCC"
      >
        <g>
          <g
            transform="translate(1866.000000, 23.000000)"
          >
            <g transform="translate(1.500000, 0.000000)">
              <path d="M10.5,24.0000007 C4.7105,24.0000007 0,19.4080006 0,13.7640004 C0,9.31550026 2.954,5.40100014 7.3505,4.0230001 C7.615,3.93950009 7.8945,4.0870001 7.977,4.35050011 C8.0595,4.61400011 7.913,4.89450012 7.6495,4.97700013 C3.7345,6.20450016 1,9.81750028 1,13.7640004 C1,18.8570006 5.2615,23.0000007 10.5,23.0000007 C15.7385,23.0000007 20,18.8570006 20,13.7640004 C20,9.75450027 17.3275,6.22350016 13.3505,4.97700013 C13.087,4.89450012 12.9405,4.61400011 13.023,4.35050011 C13.105,4.0870001 13.3845,3.93950009 13.6495,4.0230001 C18.046,5.40050014 21,9.31500026 21,13.7640004 C21,19.4080006 16.2895,24.0000007 10.5,24.0000007 Z M10.4999998,9 C10.2234998,9 9.99999976,8.776 9.99999976,8.5 L9.99999976,0.5 C9.99999976,0.224 10.2234998,0 10.4999998,0 C10.7764998,0 10.9999998,0.224 10.9999998,0.5 L10.9999998,8.5 C10.9999998,8.776 10.7764998,9 10.4999998,9 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default Logout
